export default __webpack_public_path__ + "static/media/sml-favicon.d7a85d48.png";